import { useEffect, useState } from "react";
import { getCountryOptions } from "../api/CrmApi";
import { FORM_CONTROL } from "shared/tableStyles";

interface Props {
  value: string;
  onChange: (country: string) => void;
  disabled?: boolean;
  className?: string;
}

/** Country dropdown for editing — the canonical list served by the backend
 * ("United States" first), so what's saved always matches the exact spelling
 * /rfp-outreach's US check expects. A value already on file that isn't on the
 * list is kept as an option, so opening an edit never silently drops it. */
export default function CountrySelect({ value, onChange, disabled, className }: Props) {
  const [options, setOptions] = useState<string[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getCountryOptions()
      .then((list) => !cancelled && setOptions(list))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, []);

  const withCurrent = value && !options.includes(value) ? [value, ...options] : options;
  return (
    <>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={
          className ??
          `w-full px-3 py-2 ${FORM_CONTROL}`
        }
      >
        <option value="">— not set —</option>
        {withCurrent.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
      {failed && <p className="text-[11px] text-destructive mt-1">Couldn't load the country list — reload to try again.</p>}
    </>
  );
}
